import staticData from "@/public/data/flight/passengers.json";
import Flex from "@/shared/components/common/Flex";
import {
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from "@/shared/components/common/form";
import Typography from "@/shared/components/common/Typography";

import { Checkbox } from "@/shared/components/common/Checkbox";
import type { PassengersSchemaType } from "@/shared/schemas/flight/passengersSchema";
import { useFormContext } from "react-hook-form";
import PhosphorIcon from "@/shared/components/common/PhosphorIcon";
import { cn } from "@/shared/libs/commonUtils";

interface PassengerCardHeaderProps {
  passengerIndex: number;
}

export default function PassengerCardHeader({
  passengerIndex,
}: PassengerCardHeaderProps) {
  const { internationalLabel } = staticData.forms.passengersForm;

  const { control } = useFormContext<PassengersSchemaType>();

  return (
    <Flex className="gap-y-4 max-md:w-full gap-x-4 items-center justify-start py-4">
      <FormField
        control={control}
        name={`passengers.${passengerIndex}.isInternational`}
        render={({ field }) => (
          <FormItem>
            <FormControl>
              <Flex alignItems={"center"} gap={"3"}>
                <Flex
                  alignItems={"center"}
                  gap={"2"}
                  className={cn(
                    "bg-muted dark:bg-muted/10 py-1 px-2 rounded-full ring-1 transition-all duration-100 ease-in-out cursor-pointer",
                    field.value ? "ring-primary/80" : "ring-ring",
                  )}
                >
                  <Flex
                    alignItems={"center"}
                    gap={"2"}
                    className="px-1"
                    onClick={() => field.onChange(!field.value)}
                  >
                    <PhosphorIcon
                      name={field.value ? "Check" : "QuestionMark"}
                      size={22}
                      className={
                        field.value ? "text-primary" : "text-muted-foreground"
                      }
                    />
                    <Typography
                      variant={"body3"}
                      fontWeight={"medium"}
                      className={
                        field.value
                          ? "text-foreground"
                          : "text-muted-foreground"
                      }
                    >
                      {internationalLabel}
                    </Typography>
                  </Flex>
                </Flex>
              </Flex>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </Flex>
  );
}
